import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CignaSSOError = () => (
	<Box
		display='flex'
		flexDirection='column'
		alignItems='center'
		justifyContent='flex-start'
		mt={6}
		mx={4}
	>
		<Typography variant='h6' component='h1' gutterBottom>
			Oops! Sorry, we couldn’t sign you in.
		</Typography>
		<Typography variant='body1' gutterBottom>
			Please connect with your manager or Cigna’s Tech Central for further
			assistance.
		</Typography>
	</Box>
);

export default CignaSSOError;
